// removed by extract-text-webpack-plugin
module.exports = {"ratings":"Ratings__ratings___GBI14","text":"Ratings__text___2aSaf","icon":"Ratings__icon___3yKWO"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/reference/components/Ratings.scss
// module id = 1737
// module chunks = 0